export const ACCOUNT_ID_PARAM_NAME = 'accountId';
export const SCHEDULED_REPORTS_ID_PARAM = 'scheduledReportId';
export const ACCOUNT_ID_PARAM_TEMPLATE = `/:${ACCOUNT_ID_PARAM_NAME}?`;
export const SCHEDULED_REPORTS_ID_PARAM_TEMPLATE = `/:${SCHEDULED_REPORTS_ID_PARAM}?`;
